import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateProjectReportPublicLinkMutationVariables = Types.Exact<{
  reportId: Types.Scalars['ID']['input'];
}>;


export type CreateProjectReportPublicLinkMutationPage = { readonly __typename?: 'RootMutationType', readonly createProjectReportPublicLink: { readonly __typename?: 'ProjectReportPublicLink', readonly slug: string, readonly password?: string | null } };

export type DeleteProjectReportPublicLinkMutationVariables = Types.Exact<{
  reportId: Types.Scalars['ID']['input'];
}>;


export type DeleteProjectReportPublicLinkMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteProjectReportPublicLink: boolean };


export const CreateProjectReportPublicLinkDocument = gql`
    mutation CreateProjectReportPublicLink($reportId: ID!) {
  createProjectReportPublicLink(reportId: $reportId) {
    slug
    password
  }
}
    `;
export type CreateProjectReportPublicLinkMutationFn = Apollo.MutationFunction<CreateProjectReportPublicLinkMutationPage, CreateProjectReportPublicLinkMutationVariables>;

/**
 * __useCreateProjectReportPublicLinkMutation__
 *
 * To run a mutation, you first call `useCreateProjectReportPublicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectReportPublicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectReportPublicLinkMutation, { data, loading, error }] = useCreateProjectReportPublicLinkMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useCreateProjectReportPublicLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectReportPublicLinkMutationPage, CreateProjectReportPublicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectReportPublicLinkMutationPage, CreateProjectReportPublicLinkMutationVariables>(CreateProjectReportPublicLinkDocument, options);
      }
export type CreateProjectReportPublicLinkMutationHookResult = ReturnType<typeof useCreateProjectReportPublicLinkMutation>;
export type CreateProjectReportPublicLinkMutationResult = Apollo.MutationResult<CreateProjectReportPublicLinkMutationPage>;
export type CreateProjectReportPublicLinkMutationOptions = Apollo.BaseMutationOptions<CreateProjectReportPublicLinkMutationPage, CreateProjectReportPublicLinkMutationVariables>;
export const DeleteProjectReportPublicLinkDocument = gql`
    mutation DeleteProjectReportPublicLink($reportId: ID!) {
  deleteProjectReportPublicLink(reportId: $reportId)
}
    `;
export type DeleteProjectReportPublicLinkMutationFn = Apollo.MutationFunction<DeleteProjectReportPublicLinkMutationPage, DeleteProjectReportPublicLinkMutationVariables>;

/**
 * __useDeleteProjectReportPublicLinkMutation__
 *
 * To run a mutation, you first call `useDeleteProjectReportPublicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectReportPublicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectReportPublicLinkMutation, { data, loading, error }] = useDeleteProjectReportPublicLinkMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useDeleteProjectReportPublicLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectReportPublicLinkMutationPage, DeleteProjectReportPublicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectReportPublicLinkMutationPage, DeleteProjectReportPublicLinkMutationVariables>(DeleteProjectReportPublicLinkDocument, options);
      }
export type DeleteProjectReportPublicLinkMutationHookResult = ReturnType<typeof useDeleteProjectReportPublicLinkMutation>;
export type DeleteProjectReportPublicLinkMutationResult = Apollo.MutationResult<DeleteProjectReportPublicLinkMutationPage>;
export type DeleteProjectReportPublicLinkMutationOptions = Apollo.BaseMutationOptions<DeleteProjectReportPublicLinkMutationPage, DeleteProjectReportPublicLinkMutationVariables>;